import { render, staticRenderFns } from "./VideoListVerticalItem.vue?vue&type=template&id=1a96a680&scoped=true&"
import script from "./VideoListVerticalItem.vue?vue&type=script&lang=js&"
export * from "./VideoListVerticalItem.vue?vue&type=script&lang=js&"
import style0 from "./VideoListVerticalItem.vue?vue&type=style&index=0&id=1a96a680&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a96a680",
  null
  
)

export default component.exports